import { render, staticRenderFns } from "./Consume.vue?vue&type=template&id=655b1bc8&"
import script from "./Consume.vue?vue&type=script&lang=js&"
export * from "./Consume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports